import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Gamepad2, Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

function formatErr(detail) {
  if (!detail) return "Login failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("admin@gamingkits.online");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Admin");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-charcoal px-4">
      <div className="absolute inset-0 cyber-grid opacity-40" />
      <div className="relative w-full max-w-sm rounded-2xl border border-border bg-slateSurface p-8 shadow-2xl">
        <Link to="/" className="mb-6 flex items-center justify-center gap-2">
          <Gamepad2 className="h-6 w-6 text-neon" />
          <span className="font-display text-sm font-black tracking-wider text-white">GAMING<span className="text-neon">MOBILE</span>PRICE</span>
        </Link>
        <h1 className="text-center font-heading text-xl font-bold text-white">Admin / CMS Login</h1>
        <p className="mt-1 text-center text-xs text-slate-400">Manage devices & guides</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs text-slate-400">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 w-full rounded-lg border border-border bg-graphite px-3 py-2.5 text-sm text-white focus:border-neon/50 focus:outline-none" />
          </div>
          <div>
            <label className="text-xs text-slate-400">Password</label>
            <div className="mt-1 flex items-center gap-2 rounded-lg border border-border bg-graphite px-3 focus-within:border-neon/50">
              <Lock className="h-4 w-4 text-slate-500" />
              <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Enter password" className="w-full bg-transparent py-2.5 text-sm text-white focus:outline-none" />
            </div>
          </div>
          <button data-testid="login-submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-lg bg-neon py-2.5 text-sm font-heading font-bold text-charcoal transition-all hover:shadow-[0_0_18px_rgba(57,255,20,0.5)] disabled:opacity-60">
            <LogIn className="h-4 w-4" /> {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
